import React, { Component } from "react";
import DataTable from "react-data-table-component";
import authService from "../../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";
import Popup from "react-popup";

export default class AhorroProgPaso2 extends Component {

  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    datosCuenta: [],
    toggle: true,
    porSuerte: false,
    nroContrato: -1,
    cuentaOrigen: {},
    plan: {},
    nombreCompletoSocio: authService.getSocio().nombreCompleto.trim()
  });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  confirmar = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.monto.split('.').join('');
    importe = String(importe).replace(/\,/g, ".");

    let data = {

      canal: "CU24HS_WEB",
      idMoneda: "GS",
      idModalidad: this.props.plan.idModalidad,
      importe: importe

    }

    trackPromise(
      HabilitarAhorroProgramadoService.aperturaCuentaAhorroProgramado(data)
        .then((response) => {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);

          if(jData !== undefined && jData.codigo !== null){
            if (jData.codigo === 0) {
              this.props.returnDataPaso2(jData.datos.idAhorro, jData.datos.fechaVencimiento);
              this.nextStep.click();
            }else{
              Popup.queue(this.notifiPopup("Atención", jData.mensaje));
            }
          } else {
            Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
          }
        })
    ).catch(function (error) {  
      console.log(error)
      this.btn.removeAttribute("disabled");
      Popup.queue(Popup.register({
        title: "Error Inesperado.",
        content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
        buttons: {
          right: [
            {
              text: "Aceptar",
              className: "success",
              action: function () {
                Popup.close();
              },
            },
          ],
        },
      }));
    });
  }

  render() {

    const columns = [
      {
        name: "concepto",
        selector: "concepto",
      },
      {
        name: "valor",
        selector: "valor",
      },
    ];

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">1</span>
                    <span className="title_text">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="number current">2</span>
                    <span className="title_text current">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">3</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-8">
              <section className="content">
                <div className="container-fluid"> 
                  {/* <div className="row">
                    <div className="col-md-8">
                    <label className="input-label">
                      Cuenta Origen (a debitar): 
                    </label>
                    <br/>
                      <span>
                      {this.props.cuentaOrigen.ahorro} - {this.state.nombreCompletoSocio}
                      </span>
                      <div className="inner"style={{paddingTop: 2,paddingBottom: 1,}}>
                        <h6 style={{ margin: 0 }}>
                          Tipo: {this.props.cuentaOrigen.descripcion}
                        </h6>
                        <p style={{ margin: 1 }}>
                          Moneda: {this.props.cuentaOrigen.moneda}
                        </p>
                      </div>
                    </div>                    
                  </div> */}

                  <div className="row">     
                    <div className="table-responsive">
                      <table className="table">
                        <tbody>
                          <tr>
                            <th>Plan Seleccionado:</th>
                            <td>{this.props.plan.descripcion}</td>
                          </tr>
                          <tr>
                            <th>Tasa de Interés (%):</th>
                            <td>{this.props.plan.interes}</td>
                          </tr>
                          <tr>
                            <th>Importe mensual:</th>
                            <td>{this.props.monto}</td>
                          </tr>
                          <tr>
                            <th>Importe total a percibir:</th>
                            <td>{this.props.montoFinal}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <label
                      className="input-label-bold-obligatorio float-left">
                      (*) La tasa vigente está sujeta a variaciones
                      <br />
                    </label>
                  </div>
                  
                  <div className="row">
                    <div className="col-12">
                      <div className="card"
                        style={{
                          padding: 4,
                          border: "1px solid #007c34",
                          color: "rgb(58, 58, 58)",
                          boxShadow: "none",
                        }}>
                        <p>
                          Declaro bajo la fe de Juramento que los fondos de
                          todas las operaciones y transacciones que realizo
                          o realizaré con la <strong>UNIVERSITARIA LTDA. </strong>
                          durante mi vinculación comercial con la
                          Institución, cualquiera sea su naturaleza,
                          denominación, condición o modalidad de las mismas,
                          provienen y/o provendrán de fuentes lícitas
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
          </div>
        </div>

        <hr/>  

        <div className="row">
          <div className="col-md-10">
            <div className="row float-right"> 
              <label className="input-label-bold float-left" style={{marginTop:10}}>
                Esta seguro que desea CONFIRMAR la operación?<br/>
              </label> 
            </div>
          </div>
          <div className="col-md-2">    
            <div className="row float-right"> 
              <button
                onClick={this.props.previousStep}
                type="button"
                className="btn btn-cu-secundary float-right"
                style={{ marginRight: "5px" }}>
                Volver
              </button>
              <button ref={btn => { this.btn = btn; }}
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={this.confirmar}>
                Confirmar
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}></button>
              <button
                hidden
                ref={(a) => (this.previousStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.previousStep}></button>
            </div>
          </div>       
        </div>
      </div>
    );
  }
}

